import Loader from '../Loader';

export const PageLoader = () => {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background-base-surface-1">
      <Loader />
    </div>
  );
};
